export const FORM_NAME = 'register';



// WEBPACK FOOTER //
// ./src/register/constants.js